export default {
  customer: {
    id: 'bo_seller_customer_reviews_customer',
    defaultMessage: 'Customer',
  },
  creationDate: {
    id: 'bo_seller_customer_reviews_date',
    defaultMessage: 'Date',
  },
  market: {
    id: 'bo_seller_customer_reviews_market',
    defaultMessage: 'Market',
  },
  orderId: {
    id: 'bo_seller_customer_reviews_order_id',
    defaultMessage: 'Order #',
  },
  rate: {
    id: 'bo_seller_customer_reviews_rating',
    defaultMessage: 'Rating',
  },
  comment: {
    id: 'bo_seller_customer_reviews_review',
    defaultMessage: 'Review',
  },
}
